module.exports = __webpack_public_path__ + "img/pc-title-icon.316e9f5d.png";